import * as React from 'react';
import { UserLanguageProvider } from '../i18n';
import { AdProvider } from '../Ad';
import { jsx as _jsx } from "react/jsx-runtime";
var DocsConfigContext = /*#__PURE__*/React.createContext(null);
if (false) DocsConfigContext.displayName = "DocsConfigContext";
export function DocsProvider(_ref) {
  var config = _ref.config,
    adConfig = _ref.adConfig,
    defaultUserLanguage = _ref.defaultUserLanguage,
    translations = _ref.translations,
    children = _ref.children;
  return /*#__PURE__*/_jsx(DocsConfigContext.Provider, {
    value: config,
    children: /*#__PURE__*/_jsx(AdProvider, {
      config: adConfig,
      children: /*#__PURE__*/_jsx(UserLanguageProvider, {
        defaultUserLanguage: defaultUserLanguage,
        translations: translations,
        children: children
      })
    })
  });
}
export function useDocsConfig() {
  var config = React.useContext(DocsConfigContext);
  if (!config) {
    throw new Error('Could not find docs config context value; please ensure the component is wrapped in a <DocsProvider>');
  }
  return config;
}